import { Board, Column } from '@gamma/ui/layout';
import { Outlet, useLocation } from 'react-router';
import { PageHeader } from '../../../shared/components';
import { ROUTES } from '../../../shared/constants/routes';
import { i18n } from '../../../shared/localization';

const { alertExport, generalSettings, securityAudit, sensorMonitoring } =
  i18n.navigation.system;

const {
  systemSettingsAlertCatalog,
  systemSettingsSensorMonitoring,
  systemSettingsIntegrationsAlertExports,
  systemSettingsSecurityAudit,
  systemSettingsGeneral,
  systemSettingsIntegrations,
} = ROUTES;

export const System = () => {
  const { pathname } = useLocation();

  const pageTitle = {
    [systemSettingsAlertCatalog()]: '',
    [systemSettingsSensorMonitoring]: sensorMonitoring,
    [systemSettingsIntegrationsAlertExports]: alertExport,
    [systemSettingsSecurityAudit()]: securityAudit,
    [systemSettingsGeneral]: generalSettings,
  }[pathname];

  return (
    <Board flexGrow={1} flexWrap="inherit" flexDirection="column">
      <Column
        flexGrow={1}
        display="flex"
        flexBasis="auto"
        flexDirection="column"
      >
        {!pathname.includes(`${systemSettingsAlertCatalog()}/`) &&
          !pathname.includes(`${systemSettingsIntegrations}/`) && (
            <PageHeader>{pageTitle}</PageHeader>
          )}
        <Outlet />
      </Column>
    </Board>
  );
};
